import { capitalized } from "common/utils/strings";
import { Optional } from "common/utils/types";
import { FetchError, StatusCode } from "common/fetch/types";
import errorImages from "common/constants/errorImages";

import ErrorContainer from "./ErrorContainer";

export type FetchErrorContainerProps = {
  error: Optional<FetchError>;
  image?: string;
  entityName: string;
  isPlural?: boolean;
};

const FetchErrorContainer = ({
  error,
  entityName,
  image,
  isPlural = false,
  ...rest
}: FetchErrorContainerProps) => {
  if (error?.status === StatusCode.NotFound) {
    return (
      <ErrorContainer
        title={`${capitalized(entityName)} not found!`}
        description={`Sorry, the ${entityName} you are looking for ${
          isPlural ? "do" : "does"
        } not exist. Either ${isPlural ? "they were" : "it was"} removed or you mistyped the url.`}
        image={image || errorImages.Error404}
        imageAlt="Nothing found"
        {...rest}
      />
    );
  }

  return (
    <ErrorContainer
      title="Oh no!"
      description={`The server encountered an internal error or misconfiguration and was unable to fetch ${
        isPlural ? "these" : "this"
      } ${entityName}.`}
      image={image || errorImages.Error500}
      imageAlt="Internal Error"
      {...rest}
    />
  );
};

export default FetchErrorContainer;
